<sl-map *ngIf="assignments != null && datasource != null" #map
        [lng]="initialLng" [lat]="initialLat"
        access-token="pk.eyJ1IjoibWljaGFlbGtyb2ciLCJhIjoiY2szdHp0Y3RzMDd0NjNrcTh2ZXloZ2JqMyJ9.XYFkQDw6jLJk1iBmNe7tGA"
        (slMove)="onMapMove($any($event))">
</sl-map>

<div class="intro" *ngIf="assignments == null">
    <div class="intro-content mt-8">
        <sl-label i18n size="x-large">Select a date in the timeline</sl-label>
        <sl-label i18n size="small" class="mb-2">or checkout this video to view an introduction</sl-label>
        <ws-video-player [options]="{autoplay: false, controls: true, width: 300, sources: [{ src: introFile, type: 'video/mp4' }]}"></ws-video-player>
    </div>
</div>

<sl-popover #popover placement="right" distance="2" style="--background: var(--sl-color-gray-100);--border-color: var(--sl-color-gray-300)" (slHide)="onPopoverHide($any($event))">
    <app-assignment-preview-dialog 
    [assignment]="value" 
    [contact]="contact"
    [agreementSummaries]="agreementSummaries"
    [autoNotificationEnabled]="autoNotificationEnabled"
    [allowManualNotification]="allowManualNotification"
    (editAssignment)="onEditAssignment()" 
    (skipAssignment)="onSkipAssignment()" 
    (startAssignment)="onStartAssignment()" 
    (completeAssignment)="onCompleteAssignment()"
    (openContact)="onOpenContact()"
    (openReference)="onOpenReference($event)"
    (sendNotification)="onSendNotification()"
    (click)="$event.stopPropagation()"
    (delete)="deleteAssignment.emit()"
    (lock)="onLock()"
    (unlock)="onUnlock()"
    >
</app-assignment-preview-dialog>
</sl-popover>
